import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import Hours from '../../../smoothr-web-app-core/models/Hours';
import moment from 'moment';

@Component({
	selector: 'app-working-hours-modal',
	templateUrl: './working-hours-modal.component.html',
	styleUrls: ['working-hours-modal.component.scss'],
})
export class WorkingHoursModalComponent implements OnChanges {
	@Input() schedule: Hours[] = [];
	@Input() language: string = 'en';
	@Input() venueName: string;
	formattedHours: string[] = [];

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['schedule'] || changes['language']) {
			this.formatOpeningHours();
		}
	}

	formatOpeningHours(): void {
		const sorted = [];

		// Group opening hours by weekday
		this.schedule.forEach(({ weekday, openedAt, closedAt }, index) => {
			const dayName = moment()
				.weekday(weekday + 1)
				.locale(this.language)
				.format('dd')
				.toUpperCase();

			const timeRange = `${moment(openedAt, 'HH:mm').format('HH:mm')} – ${moment(closedAt, 'HH:mm').format('HH:mm')}`;

			const idx = sorted.findIndex(i => i[0] === timeRange);
			if (idx === -1) sorted.push([timeRange, dayName]);
			else if (sorted?.[sorted.length - 1]?.[0] !== timeRange) sorted.push([timeRange, dayName]);
			else {
				const currDays: string = sorted[idx][1];
				const updatedDays = currDays.includes(' ') ? currDays.substring(0, 2) + ` ${dayName}` : currDays + ' ' + dayName;
				sorted[idx] = [timeRange, updatedDays];
			}
		});

		this.formattedHours = sorted.map(d => `${d[1]}: ${d[0]}`);
	}
}
